import memeService from "../../../../services/MemeService";
import "./BrowserSourceContent.css";
import { useState, useCallback } from "react";
import BlueButton from "../../../common/BlueButton/BlueButton";
import Container from "../../../common/Container";
import notificationService from "../../../../services/NotificationService";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import { useTranslation } from "react-i18next";
import useAsync from "../../../../services/useAsync";
import GlobalConstants from "../../../../globals/GlobalConstants";

const BrowserSource = () => {
    const { t } = useTranslation("settings");

    const [fetchedData, setFetchedData] = useState("...");
    const [urlIdClass, setUrlIdClass] = useState("urlIDTextDisplayBlur");
    const [isButtonOff, setIsButtonOff] = useState(true);
    const [loading, setLoading] = useState(true);

    const getUrl = useCallback(async () => {
        let browserSourceResponse = await memeService.getBrowserSource();

        if (browserSourceResponse.url) {
            setFetchedData(browserSourceResponse.url);
            setIsButtonOff(false);
        } else {
            let createdBS = await memeService.createBrowserSource();
            if (createdBS.url) {
                setFetchedData(createdBS.url);
                setIsButtonOff(false);
            } else {
                notificationService.setMessage(
                    t("browserSourcePageSomethingWentWrongGettingUrl"),
                );
            }
        }
    }, [t]);

    const generateNewUrl = async () => {
        let createdBS = await memeService.createBrowserSource();
        if (createdBS.url) {
            setFetchedData(createdBS.url);
            notificationService.setTitle(
                t("browserSourcePageTitleNotifcationDisplay"),
            );
            notificationService.setMessage(
                t("browserSourceGenerateNewUrlMessage"),
            );
        } else {
            notificationService.setMessage(
                t("browserSourcePageSomethingWentWrongGenerateNewUrl"),
            );
        }
    };

    const generateNewUrlQuestion = () => {
        notificationService.setMessage(
            t("browserSourcePageGenerateNewUrlQuestion"),
        );
        notificationService.setTitle(
            t("browserSourcePageTitleNotifcationDisplay"),
        );

        //delete
        notificationService.setButtonText(t("deleteButtonText"));
        notificationService.onClick(async () => {
            //reset the window
            notificationService.clearAll();
            await generateNewUrl();
        });

        // cancel
        notificationService.setButtonText2(t("cancelButtonText"));
        notificationService.onClick2(() => {
            //reset the window
            notificationService.clearAll();
        });
    };
    const copyToClipboard = async () => {
        const sourceUrl = GlobalConstants.baseUrl
            ? fetchedData.replace(
                  "https://streammemes.gg",
                  GlobalConstants.baseUrl,
              )
            : fetchedData;

        await navigator.clipboard.writeText(sourceUrl);
        notificationService.setMessage(t("browserSourcePageCopyToClipboard"));
        notificationService.setTitle(
            t("browserSourcePageTitleNotifcationDisplay"),
        );
    };

    const changeUrlDisplay = () => {
        if (urlIdClass === "urlIDTextDisplayBlur")
            setUrlIdClass("urlIDTextDisplay");
        else setUrlIdClass("urlIDTextDisplayBlur");
    };

    const loadPage = useCallback(async () => {
        setLoading(true);
        await Promise.all([getUrl()]);

        setLoading(false);
    }, [getUrl]);

    useAsync(loadPage);

    let content1 = (
        <div className="urlID">
            <p className="browserSourceDescription">
                {t("browserSourcePageDescription")}
            </p>
            <div className="browserSourceLinkAndButton">
                <BlueButton
                    text={
                        urlIdClass === "urlIDTextDisplayBlur"
                            ? t("browserSourcePageShow")
                            : t("browserSourcePageHide")
                    }
                    onClick={changeUrlDisplay}
                    isDark={true}
                    isGray={isButtonOff}
                />
                <p className={urlIdClass}>
                    {GlobalConstants.baseUrl
                        ? fetchedData.replace(
                              "https://streammemes.gg",
                              GlobalConstants.baseUrl,
                          )
                        : fetchedData}
                </p>
            </div>
            <div className="CopyButtonBrowserSource">
                <BlueButton
                    isLarge={true}
                    text={t("browserSourcePageCopyButtonText")}
                    onClick={copyToClipboard}
                    isGray={isButtonOff}
                />
            </div>
            <div className="warningContainerUrlId">
                <img
                    className="warningSignImage"
                    src="/warningSign.svg"
                    alt="warning"
                />
                <span className="warningSignText">
                    {t("browserSourcePageWarningText")}{" "}
                </span>
            </div>
        </div>
    );

    let content2 = (
        <>
            <p className="browserSourceDescription">
                {t("browserSourcePageDescriptionRegenerate")}
            </p>
            <div className="regenerateButtonContainer">
                <BlueButton
                    text={t("browserSourcePageRegenerateUrlButton")}
                    onClick={generateNewUrlQuestion}
                    isLarge={true}
                    color="red"
                />
            </div>
            <div className="warningContainerUrlId">
                <img
                    className="warningSignImage"
                    src="/warningSign.svg"
                    alt="warning"
                />
                <span className="warningSignText">
                    {t("browserSourcePageDisplayWarningRegenerateUrl")}
                </span>
                <img
                    className="warningSignImage"
                    src="/warningSign.svg"
                    alt="warning"
                />
            </div>
        </>
    );

    let allContent = <LoadingDisplay />;

    if (!loading) {
        allContent = (
            <div className="scrollableContainer">
                <Container
                    title={t("browserSourcePageTitleObsUrl")}
                    content={content1}
                />
                <Container
                    title={t("browserSourcePageTitleObUrlRegenerate")}
                    content={content2}
                />
            </div>
        );
    }
    return allContent;
};

export default BrowserSource;
